module.exports = __webpack_public_path__ + "img/about-page5-img-4.9c0956cd.jpg";